import './style/style.scss';

import './submenu.js';
import './controllers/submenuParentController.js';
import './controllers/submenuController.js';
import './controllers/submenuContainerController.js';
import './directives/submenuDirectives.js';
import './services/submenuService.js';
